export const pdfReportTypes = [
  'Site summary',
  'All urgent equipment',
  'Maintenance summary',
];

export const pdfReportTypesMap = {
  'Site summary': 'site-summary-all',
  'All urgent equipment': 'site-summary-all-urgent',
  'Maintenance summary': 'maintenance-summary',
};

export const parentComp = [
  'SiteDetails',
  'ReportsDialog',
  'EquipmentsReport',
  'SiteSummary',
];

export const parentCompReports = [
  'SiteDetails',
  'ReportsDialog',
  'EquipmentsReport',
];

export const reportTemplates = [
  /* { key: 'cortixTemplate', value: 'CORTIX_Template' }, */
  { key: 'aboundTemplate', value: 'Abound_Template' },
];
export const initialReportTemplate = 'cortixTemplate';
export const aboundReportTemplate = 'aboundTemplate';

export const pdfChartsPaddingBottom = {
  en: 90,
  es: 90,
  zh: 70,
  fr: 75,
  de: 90,
  nl: 90,
  it: 75,
  ar: 220,
  tr: 90,
  ja: 70,
  th: 90,
};

export const pdfLastPageMarginBottom = {
  en: 180,
  es: 120,
  zh: 60,
  fr: 180,
  de: 180,
  nl: 180,
  it: 180,
  ar: 60,
  tr: 180,
  ja: 60,
  th: 180,
};

export const pdfLastPage = {
  Carrier: 'Carrier',
  Abound: 'Abound',
  Insights: 'Insights ',
  Assistant: 'Assistant ',
  Predictive: 'Predictive',
  SaaS: 'SaaS',
  managed: 'managed',
  services: 'services',
  artificial: 'artificial',
  intelligence: 'intelligence',
  platform: 'platform',
  aboundWebsite: 'abound.carrier.com',
  LinkedIn: 'LinkedIn',
  X: 'X',
  YouTubeChannel: 'YouTube channel',
  Facebook: 'Facebook',
};

export const stylesForPdf = {
  dynamicContentUrgentHeader: {
    en: 20,
    es: 40,
    zh: 10,
    fr: 40,
    de: 40,
    nl: 40,
    it: 40,
    ar: 40,
    tr: 40,
    ja: 5,
    th: 20,
  },
};

export const pdfHistCompType = ['recom', 'repairs'];

export const SITE_LIST_EXPORT_OPTIONS = [
  { key: 'equipmentList', value: 'All_equipment_list' },
  { key: 'urgentEquipmentList', value: 'All_urgent_equipment_list' },
];
export const SITE_LIST_FILTERED_EQ_OPTION = {
  key: 'filteredTodoList',
  value: 'Filtered_equipment_To-do_list',
};

export const SITE_LIST_EQUIPMENT_ENERGY_OPTION = {
  key: 'equipmentEnergyReport',
  value: 'Equipment_and_Energy_reports',
};

export const SITE_LIST_AVAILABLE_DOWNLOADS_OPTION = {
  key: 'availableDownloads',
  value: 'Available_downloads',
};

export const SITE_LIST_REPORT_OPTION = {
  key: 'siteList',
  value: 'Site_list',
};

export const SITE_LIST_WORKORDER_REPORT_OPTION = {
  key: 'siteListWorkOrder',
  value: 'Site_list_with_work_orders',
};

export const URGENT_REPORT_CODE = 'URGENT';

export const defaultPaiForReport = {
  selection: { withRecommendations: true, withoutRecommendations: false },
  workOrder: false,
  repairs: false,
  parts: false,
  events: false,
  dateRange: { start: '', end: '' },
  withNoFeedBackAndServiceNotes: false,
};

export const SITE_LIST_REPORT_TYPE = 'SITE_LIST';
export const FILTER_EQ_TODO_LIST_REPORT_TYPE = 'EQ_TODO_LIST';
export const SITE_SUMMARY_REPORT_TYPE = 'SITE_SUM';
export const EQUIPMENT_ENERGY_REPORT_TYPE = 'TMP_AND_CONS';

export const PREVIOUS_DOWNLOAD_POOLING_TIME = 2000;
export const PREVIOUS_DOWNLOAD_DURATION = 48;
export const REQUEST_EXISTS_MSG = 'Request already exists';

export const REPORT_STATUS = {
  pending: 'pending',
  completed: 'completed',
  inProgress: 'in-progress',
  error: 'error',
};

export const PREV_DOWNLOAD_COUNT = 60;
export const defaultDaysForReports = 365;

export const defaultAdditionalFilterParams = {
  feedBackAndServiceNotes: false,
  workOrder: false,
  repairs: false,
  parts: false,
  events: false,
  withNoFeedBackAndServiceNotes: false,
  selection: { withRecommendations: true, withoutRecommendations: false },
  dateRange: {},
};

export const RECOMMENDATION_OPTIONS = [
  'withRecommendation',
  'withoutRecommendation',
];
export const EXCLUDED_PAI_FIELD = ['selection', 'dateRange'];

export const WITHOUT_FEEDBACK_SERVICE_NOTES = {
  displayLabel: 'Equipment_without_any_feedback_and_service_notes_entry',
  name: 'withNoFeedBackAndServiceNotes',
};

export const FEEDBACK_AND_SERVICE_NOTES = {
  displayLabel: 'Include_feedback_and_service_notes_data',
  name: 'feedBackAndServiceNotes',
};

export const FILTER_SWITCH_PARAMS = [
  {
    displayLabel: 'With_work_orders',
    name: 'workOrder',
  },
  {
    displayLabel: 'With_repairs',
    name: 'repairs',
  },
  {
    displayLabel: 'With_parts',
    name: 'parts',
  },
  {
    displayLabel: 'With_events',
    name: 'events',
  },
];

export const ADDITIONAL_FILTER_SORT_ORDER = Object.freeze({
  feedBackAndServiceNotes: 0,
  withRecommendations: 1,
  withoutRecommendations: 2,
  workOrder: 3,
  repairs: 4,
  parts: 5,
  events: 6,
});

export const ADDITIONAL_FILTER_KEY_TEXT_MAP = {
  feedBackAndServiceNotes: 'Feedback_and_service_notes',
  withRecommendations: 'With_recommendations',
  withoutRecommendations: 'Without_recommendations',
  workOrder: 'workorder',
  repairs: 'repairs',
  parts: 'parts',
  events: 'events',
};

/**
 * Report Name field limit for Generate Reports dialog.
 * Primary limit: 300 characters.
 * Word estimate uses ~6 chars/word (5 letters + space) → ~50 words.
 * Field stays 3 visible rows; longer text scrolls within the input.
 */
export const REPORT_NAME_MAX_LINES = 3;
export const REPORT_NAME_AVG_CHARS_PER_WORD = 6;
export const REPORT_NAME_MAX_CHARS = 300;
export const REPORT_NAME_MAX_WORDS = Math.floor(
  REPORT_NAME_MAX_CHARS / REPORT_NAME_AVG_CHARS_PER_WORD,
);
